import { Role } from './roles';

enum Page {
  ROOT = 'ROOT',
  PROJECTS = 'PROJECTS',
  IMPORTS = 'IMPORTS',
  ADMIN = 'ADMIN',
}

/**
 * Since every page is accessed only if the user owns certain roles,
 * we must define a set of Pages and the roles of every page
 */

export const PAGE_ROLES: Record<Page, Array<string>> = {
  ROOT: [Role.ADMIN, Role.PMO],
  PROJECTS: [Role.ADMIN, Role.PMO],
  IMPORTS: [Role.ADMIN, Role.PMO],
  ADMIN: [Role.ADMIN],
};

export const PAGE_PATHS: Record<Page, string> = {
  ROOT: '/',
  PROJECTS: '/projects',
  IMPORTS: '/imports',
  ADMIN: '/admin',
};

export default Page;
